import { InlineBanner } from "components/ui/inline-banner";
import { SecondaryCompactButton } from "components/ui/secondary-button";
import React from "react";

interface RetryableErrorBannerProps {
    message: string;
    onRetry: () => void;
    retrying: boolean;
}

export const RetryableErrorBanner: React.FC<RetryableErrorBannerProps> = props => {
    const { message, onRetry, retrying } = props;

    return (
        <InlineBanner type="error">
            <div className="flex items-center justify-between gap-3">
                <span>{message}</span>
                <SecondaryCompactButton
                    type="button"
                    className="shrink-0"
                    onClick={onRetry}
                    disabled={retrying}>
                    Try again
                </SecondaryCompactButton>
            </div>
        </InlineBanner>
    );
};
